import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      id: 1,
      question: 'How does the AI maintain my writing voice?',
      answer: `Our AI Agent 2 analyzes your existing content (blog posts, articles, emails) to learn your unique writing style, tone, and vocabulary. It captures patterns in sentence structure, word choice, and communication style. This profile is then applied across all AI agents to ensure your book sounds authentically like you, not generic AI content.`
    },
    {
      id: 2,
      question: 'What\'s included in each subscription tier?',
      answer: `All tiers include access to all 11 AI agents, writing voice capture, print and ebook formatting, cover design, KDP metadata generation, and automatic Skool community access. Higher tiers offer more book credits, faster processing, priority support, and additional features like strategy calls and bulk export options.`
    },
    {
      id: 3,
      question: 'How long does it take to create a complete book?',
      answer: `Most users complete their first book in 4-8 weeks, depending on the writing path chosen. Automatic full manuscript generation can produce a complete draft in days, while chapter-by-chapter collaboration takes longer but offers more creative control. The AI handles research, outlining, writing, formatting, and cover design—tasks that traditionally take months or years.`
    },
    {
      id: 4,
      question: 'Can I edit the AI-generated content?',
      answer: `Absolutely! You have complete control over all content. The AI provides high-quality drafts that you can edit, refine, and customize. In chapter-by-chapter mode, you collaborate with the AI in real-time, providing feedback and direction. The platform includes built-in editing tools, and you can export your manuscript at any time for external editing.`
    },
    {
      id: 5,
      question: 'What is the Skool community access?',
      answer: `All paid members automatically receive access to our exclusive Skool community—a private network of authors, entrepreneurs, and publishing experts. Connect with fellow authors, share strategies, get feedback on your work, participate in live workshops, and access exclusive resources. It's a supportive environment designed to accelerate your publishing success.`
    },
    {
      id: 6,
      question: 'Do you help with Amazon KDP publishing?',
      answer: `Yes! AI Agent 11 provides step-by-step guidance through the entire Amazon KDP publishing process. We generate all required metadata (categories, keywords, descriptions), format your book for both print and ebook, create your cover files, and provide detailed instructions for uploading to KDP. While we don't publish directly to your account, we make the process as simple as possible.`
    },
    {
      id: 7,
      question: 'What if I run out of book credits?',
      answer: `You can upgrade to a higher tier at any time to get more book credits. Your unused credits roll over to the next month. If you're on the Starter plan and need more books, upgrading to Professional gives you 4 books total. Enterprise tier offers unlimited book creation with no credit restrictions.`
    },
    {
      id: 8,
      question: 'Is there a money-back guarantee?',answer: `Yes! We offer a 30-day money-back guarantee on all paid plans. If you're not satisfied with the platform within the first 30 days, contact our support team for a full refund. We're confident you'll love the results, but we want you to feel secure in your investment.`
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section className="pt-20 lg:pt-24 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary/10 rounded-full mb-6">
            <Icon name="HelpCircle" size={16} color="var(--color-primary)" />
            <span className="text-sm font-medium text-primary">Frequently Asked Questions</span>
          </div>

          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-foreground mb-6">
            Everything You Need to Know
          </h2>

          <p className="text-lg text-muted-foreground">
            Have questions? We've got answers. Can't find what you're looking for? Contact our support team.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs?.map((faq, index) => (
            <div
              key={faq?.id}
              className="bg-card border border-border rounded-xl overflow-hidden transition-shadow duration-300 hover:shadow-md"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-muted/50 transition-colors duration-200"
              >
                <span className="text-base font-semibold text-foreground pr-4">
                  {faq?.question}
                </span>
                <Icon
                  name={openIndex === index ? 'ChevronUp' : 'ChevronDown'}
                  size={20}
                  className="flex-shrink-0 text-muted-foreground"
                />
              </button>

              {openIndex === index && (
                <div className="px-6 pb-5 animate-fade-in">
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {faq?.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-muted-foreground mb-4">
            Still have questions?
          </p>
          <div className="flex items-center justify-center space-x-2">
            <Icon name="Mail" size={16} color="var(--color-primary)" />
            <a
              href="mailto:success@entrepreneurpowernetwork.com"
              className="text-sm font-medium text-primary hover:underline"
            >
              success@entrepreneurpowernetwork.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;